<script lang="ts">

    import PriceToTwoDp from "./PriceToTwoDp.svelte";
    import {discountToTwoDecimalPlaces} from "./stores";
    import {fetchedCoupon} from "./state/appState";
</script>

<tr>
    <td class="text-start pt-3">
        Discount
        {#if $fetchedCoupon && $fetchedCoupon.discountType === "percentage"}
            ({$fetchedCoupon.discountAmount}%)
        {/if}
    </td>
    <td class="text-end pt-3">
        <PriceToTwoDp price={$discountToTwoDecimalPlaces}/>
    </td>
</tr>
